import React from 'react';

import { ArticleList } from '@/components/ArticleList';
import { loadPosts } from '@/utils/loadPosts';
import { useAppFonts } from '@/hooks/use-fonts';

// @ts-ignore
const mdxctx = require.context('../../../../articles', true, /\.(mdx|js)$/);

const POSTS = loadPosts(mdxctx);

type PageType = {
  truncated?: boolean;
};

const App: React.FC<PageType> = React.memo(({ truncated }) => {
  const { fontsLoaded } = useAppFonts();

  return (
    <div className="space-y-6 w-full mx-auto">
      <ArticleList
        posts={POSTS}
        truncated={truncated}
        isLoading={!fontsLoaded}
      />
    </div>
  );
});

export default App;
